export class TimeStringCannotBeParsedError extends Error {
  constructor(str: string) {
    super(`Cannot parse time string: "${str}"`)
    Object.setPrototypeOf(this, TimeStringCannotBeParsedError.prototype)
  }
}
